
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { SoakStyleDto } from "./soaks.dto";

export class SoakStyleResponse extends GlobalResponseObject{

      data?: SoakStyleDto;

    constructor(status:boolean, intlCode:number, internalMessage:string, data?: SoakStyleDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}